module.exports = __webpack_public_path__ + "media/images/icons/check_circle_sea_green-da58167015ad2f0bde6890e6968a1348.svg";